import React from 'react'
import { Card, CardHeader, CardContent, CardActions, Typography } from '@mui/material'

export const CardCommon = ({headerStyle, className, ...props }) => {

  return (
    <Card className={`uiCardCommon ${className}`} variant='outlined' {...props}>
      {/* se usa customTitle para que no aparezca el tooltip automático en títulos que son componentes jsx */}
      {(props.title || props.customTitle) && props.subtitle && (
        <CardHeader
          disableTypography
          title={
            <Typography className='card-header-title' variant='h6'>
              {props.title || props.customTitle}
            </Typography>
          }
          subtitle={
            <Typography className='card-header-subtitle' variant='body2'>
              {props.subtitle}
            </Typography>
          }
        />
      )}
      {(props.title || props.customTitle) && !props.subtitle && (
        <CardHeader
        style={headerStyle}
          disableTypography
          title={
            <Typography className='card-header-title mb-0' variant='h6'>
              {props.title || props.customTitle}
            </Typography>
          }
        />
      )}
      <CardContent>{props.children}</CardContent>
      {props.actions && <CardActions className='cardActions'>{props.actions}</CardActions>}
    </Card>
  )
}
